import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class ProductMultipleSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            products: [],
            filteredProducts: []
        };
        this.getProducts = this.getProducts.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handleItemInteraction = this.handleItemInteraction.bind(this);
        this.http = new HttpRequestService();
        this.lastMouseDownTime = new Date();
        this.handleTouch = true;
    }


    componentDidMount() {
        this.getProducts();
    }

    componentDidUpdate(prevProps) {
        if (this.props.companyId !== prevProps.companyId || this.props.productTypeId !== prevProps.productTypeId) {
            this.getProducts();
        }
    }

    componentWillUnmount() {
    }

    getProducts() {
        var params = {
            companyId: this.props.companyId,
            productTypeId: this.props.productTypeId
        }
        if (params.companyId > 0 && params.productTypeId > 0) {
            this.http.get('/api/Orders/GetProducts', params).then(data => {
                this.setState({ products: data, filteredProducts: data });
                if (data.length > 0) {
                    if (!this.props.value) {
                        this.props.onChange(data[0]);
                    }
                    else {
                        var selectedProduct = data.find(p => p.productID === this.props.value);
                        this.props.onChange(selectedProduct);
                    }
                }
            });
        }
        else if (this.props.allProducts) {
            this.http.get('/api/Inventory/GetAllProducts', params).then(data => {
                this.setState({ products: data, filteredProducts: data });
                if (!this.props.value) {
                    this.props.onChange(data[0]);
                }
                else {
                    var selectedProduct = data.find(p => p.productID === this.props.value);
                    this.props.onChange(selectedProduct);
                }
            });
        }
    }

    handleKeywordChange(e) {
        const keyword = e.target.value;
        var filteredProducts = this.state.products.filter((p) => {
            return (p.productNumber + " " + p.name).toLowerCase().indexOf(keyword.toLowerCase()) >= 0;
        });
        this.setState({ filteredProducts: filteredProducts });
    }

    handleItemInteraction(e, productID) {
        e.preventDefault();
        if (this.handleTouch === false) {
            return;
        }
        const now = new Date();
        if (now.getTime() - this.lastMouseDownTime.getTime() > 500) {
            const currentSelected = Array.isArray(this.props.value) ? [...this.props.value] : [];
            const idx = currentSelected.indexOf(productID);
            if (idx >= 0) {
                currentSelected.splice(idx, 1);
            } else {
                currentSelected.push(productID);
            }
            const products = currentSelected
                .map(id => this.state.products.find(p => p.productID === id))
                .filter(Boolean);
            this.props.onChange(products);
            this.lastMouseDownTime = new Date();
        } else {
            // double click
            if (this.props.onDoubleClick) {
                this.props.onDoubleClick();
            }
        }
    }

    render() {
        const selectedValues = Array.isArray(this.props.value) ? this.props.value : [];
        const size = this.props.size || 10;
        const height = size * 24;

        var items = this.state.filteredProducts.map((item) => {
            const isSelected = selectedValues.includes(item.productID);
            return (
                <div
                    key={item.productID}
                    onTouchStartCapture={() => this.handleTouch = true}
                    onTouchMoveCapture={() => this.handleTouch = false}
                    onTouchEndCapture={(e) => this.handleItemInteraction(e, item.productID)}
                    onMouseDown={(e) => this.handleItemInteraction(e, item.productID)}
                    style={{
                        padding: '3px 6px',
                        cursor: 'default',
                        userSelect: 'none',
                        backgroundColor: isSelected ? '#0d6efd' : 'transparent',
                        color: isSelected ? '#fff' : 'inherit',
                    }}
                >
                    {item.productNumber} - {item.name}
                </div>
            );
        });

        return (
            <>
                <input type="text" placeholder="Search..." className="form-control mb-2" onChange={this.handleKeywordChange} />
                <div
                    className="form-control product-select"
                    style={{ maxHeight: `${height}px`, overflowY: 'scroll', padding: 0 }}
                    tabIndex={0}
                >
                    {this.props.hasAllOption === true &&
                        <div
                            onTouchEndCapture={(e) => this.handleItemInteraction(e, -1)}
                            onMouseDown={(e) => this.handleItemInteraction(e, -1)}
                            style={{ padding: '3px 6px', cursor: 'default', userSelect: 'none' }}
                        >
                            -- ALL --
                        </div>
                    }
                    {items}
                </div>
            </>
        );
    }
}
export default ProductMultipleSelect
